export default "__VITE_ASSET__b8b5e3e6__"